import React, { useState, useEffect } from 'react'
import { Line } from 'react-chartjs-2';
import { bulidChartData } from 'D:/covid_19_tracker/src/utilities';
import { options } from '../../dicts';

function LineGraph({ casesType='cases', ...props }) {

    const [ data, setData ] = useState({});
    const [ color, setColor] = useState('#de1f44')
    const [ borderColor, setBorderColor] = useState('#992038')

    useEffect(() => {

        switch(casesType) {
            case 'cases':  setColor('#de1f44'); setBorderColor('#992038'); break;
            case 'recovered':  setColor('#84ff00'); setBorderColor('#7dd71d');  break;
            case 'deaths':  setColor('#3b3434'); setBorderColor('#000000'); break;
        }

        const fetchData = async () => {
            await fetch('https://disease.sh/v3/covid-19/historical/all?lastdays=120')
            .then(response => response.json())
            .then(data => {
                const chartData = bulidChartData(data, casesType)
                setData(chartData)
            });
        };

        fetchData();
    }, [casesType]);

    return (
        <div className={props.className}>
            {data?.length > 0 &&
                <Line options={options} data={{
                    datasets: [
                        {
                          data: data,
                          backgroundColor: color,
                          borderColor: borderColor
                        }
                    ]
                }} />
            }
        </div>
    )
}

export default LineGraph;
